import { useState } from "react";
import Viewer from "react-viewer";

export function ImageViewer({ imgUrls, noToolbar = true, children }) {
  const [visible, setVisible] = useState(false);

  if (!(imgUrls instanceof Array) || imgUrls.length < 1) {
    return children;
  }

  return (
    <>
      <button
        className="image-viewer-btn"
        type="button"
        onClick={() => {
          setVisible(true);
        }}
      >
        {children}
      </button>

      <Viewer
        visible={visible}
        noToolbar={noToolbar}
        defaultScale={1.25}
        minScale={1.25}
        zIndex={10000}
        noNavbar={imgUrls.length === 1}
        onClose={() => {
          setVisible(false);
        }}
        images={imgUrls.map((imgUrl) => ({ src: imgUrls }))}
      />
    </>
  );
}
